// services/sitemapService.js
import axios from 'axios';

const generateSitemap = async () => {
  const baseUrl = process.env.REACT_APP_WEB_BASE_URL;
  console.log("BASE URL:", `${baseUrl}/api/generate-sitemap`);

  try {
    const response = await axios.get(`${baseUrl}/api/generate-sitemap`);
    console.log("Sitemap generated successfully");
    return response.data; // You can return the data if needed
  } catch (error) {
    console.error("Error generating sitemap:", error);
    throw error; // Rethrow if you want to handle it further upstream
  }
};

export default {
  generateSitemap,
};
